import React from 'react';

function Input({
  id,
  name,
  value,
  onChange,
  autoComplete,
  required,
  placeholder,
  step,
  spellCheck,
  type,
  label,
  error,
  min,
  className,
  uppercase,
  autoCapitalize,
  onKeyDown,
  readOnly,
  disabled,
}) {
  return (
    <div className={`${className} inputBox w-full text-sm tracking-tight`}>
      <input
        id={id}
        name={name}
        type={type}
        placeholder=""
        required={required}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        spellCheck={spellCheck}
        value={value}
        step={step}
        min={min}
        onChange={onChange}
        onKeyDown={onKeyDown}
        readOnly={readOnly}
        disabled={disabled}
        className={`${uppercase ? 'uppercase' : ''} inputField w-full appearance-none rounded-lg border bg-surface px-3.5 py-3 text-sm text-ink placeholder-gray-400 shadow-sm transition duration-200 ease-in-out disabled:bg-gray-100 disabled:text-gray-400 ${error ? 'border-danger focus:border-danger focus:ring-danger/20' : 'border-line focus:border-gold-500 focus:ring-gold-500/20'} outline-none focus:outline-none focus:ring-4`}
      />
      <span className={`${uppercase ? 'uppercase' : ''} inputLabel text-sm`}>
        {label}
        {required && <span className="ml-1 text-danger">*</span>}
      </span>
      {error && <div className="mt-1.5 ml-1 text-xs font-medium text-danger">{error}</div>}
    </div>
  );
}

export default Input;
